// extracted by mini-css-extract-plugin
module.exports =  {"title":"q1EaCx","formContainer":"UMj_t7","form":"e_edkE"};